/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbSharedRefetchContainer_shippingFilters = ReadonlyArray<{
    readonly totalCount: number | null;
    readonly " $refType": "SbSharedRefetchContainer_shippingFilters";
}>;
export type SbSharedRefetchContainer_shippingFilters$data = SbSharedRefetchContainer_shippingFilters;
export type SbSharedRefetchContainer_shippingFilters$key = ReadonlyArray<{
    readonly " $data"?: SbSharedRefetchContainer_shippingFilters$data;
    readonly " $fragmentRefs": FragmentRefs<"SbSharedRefetchContainer_shippingFilters">;
}>;



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SbSharedRefetchContainer_shippingFilters",
  "type": "ShippingFilterType",
  "metadata": {
    "plural": true
  },
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "totalCount",
      "args": null,
      "storageKey": null
    }
  ]
};
(node as any).hash = 'd5ad44746e573a35fa3db0693e7d384d';
export default node;
